import packageJson from "../../../package.json"
import { FolderOpenOutlined, PlusCircleOutlined, InfoOutlined,CloseOutlined,SettingOutlined,PlusOutlined, ReloadOutlined } from '@ant-design/icons';


export const CONSTANTS = {
  ACCESS_LOGS: "accessLogs",
  LOGIN_LOGS: "loginLogs",
  REASON_LOGS: "reasonLogs",
  ACCESS_LOGS_FILENAME: "Access_Log",
  LOGIN_LOGS_FILENAME: "Login_Log",
  REASON_LOGS_FILENAME: "Reason_Log",
  EMPLOYEE_MASTER_DASHBOARD: "EMPLOYEE_MASTER_DASHBOARD1",
  EMPLOYEE_MASTER_SNAPSHOT: "EMPLOYEE_MASTER_SNAPSHOT",
  EMPLOYEE_MASTER_SNAPSHOT_LOGS: "EMPLOYEE_MASTER_SNAPSHOT_LOGS",
  AUTO_PROVISIONING_PROHANCE: "AUTO_PROVISIONING_PROHANCE",
  AUTO_PROVISIONING_PIXIE: "AUTO_PROVISIONING_PIXIE",
  FALCON_LOGS: "FALCON_LOGS",
  PROHANCE: 'Prohance',
  FALCON: 'Falcon',
  CAMPAIGN: 'Campaign',
  GROUP: 'Group',
  DATABASE: "Database",
  MANAGEJOBS: "ManageJobs",

};

export const MetaTitle = {
  Login: "",
  Falcon: `- ${packageJson.version} - Falcon`,
  Prohance: `- ${packageJson.version} - Prohance`,
  ProhanceCondition: `- ${packageJson.version} - Prohance Condition Filters`,
  FalconCondition: `- ${packageJson.version} - Falcon Condition Filters`,
  Dashboard: `- ${packageJson.version} - Dashboard`,
  Snapshot: `- ${packageJson.version} - Snapshot`,
  Logs: `- ${packageJson.version} - Logs`,
  LogsDetails: `- ${packageJson.version} - Logs Details`,
  FalconLogs: `- ${packageJson.version} - Falcon Logs`,
  FalconLogsDetails: `- ${packageJson.version} - Falcon Logs Details`,

}
export const DASHBOARD = {
  DOWNLOADS_BY_FUNCTION: "downloadsByFunction",
  TOP_FUNTIONS: "topFunctions",
  DOWNLOADS_BY_USER: "downloadsByUser",
  DOWNLOADS_BY_SITE: "downloadsBySite",
  RECENT_ACTIVITY: "recentActivity",
  RECENT_DOWNLOAD_REASONS: "recentDownloadReasons",
  DOWNLOADS_BY_CAMPAIGN: "downloadsByCampaign",
};

export const HEADERS_FOR_FUNCTION_DOWNLOADS = [
  { label: "Funtion Name", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_USER_DOWNLOADS = [
  { label: "Email", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_SITE_DOWNLOADS = [
  { label: "Site Name", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_RECENT_ACTIVITY = [
  { label: "User Name", key: "user_name" },
  { label: "Activity Time", key: "created_at" },
];

export const HEADERS_FOR_RECENT_DOWNLOAD_REASONS = [
  { label: "User Name", key: "user_name" },
  { label: "Reason", key: "reasons_reason" },
  { label: "Activity Time", key: "created_at" },
];

export const HEADERS_FOR_CAMPAIGN_DOWNLOADS = [
  { label: "Campaign", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_SNAPSHOT_EXPORT = [
  { label: "EMPLOYEE ID", key: "employee_id" },
  { label: "EMAIL", key: "email" },
  { label: "FULL NAME", key: "full_name" },
  { label: "HIRE DATE", key: "hire_date" },
  { label: "POSITION JOB DESCRIPTION", key: "position_job_description" },
  { label: "CAMPAIGN", key: "campaign" },
  { label: "LOB", key: "lob" },
  { label: "SITE", key: "site" },
  { label: "IS ID", key: "isid" },
  { label: "IS FIRST NAME", key: "is_first_name" },
  { label: "IS LAST NAME", key: "is_last_name" },
  { label: "OPERATIONS MANAGER", key: "operations_manager" },
  { label: "SENIOR OPERATIONS MANAGER", key: "senior_operations_manager" },
  { label: "DEPARTMENT", key: "department" },
  { label: "WORK SITE STATUS", key: "work_site_status" },
];

export const CLIENT_PROHANCE = "PROHANCE";

export const AUTO_PROVISIONING_CLIENT = {
  PROHANCE: "PROHANCE",
  FALCON: "PIXIEBRIX",
};

export const JOB_TYPE = {
  PROHANCE_AUTO_PROVISIONING: "PROHANCE_AUTO_PROVISIONING",
  PIXIEBRIX_AUTO_SYNC: "PIXIEBRIX_AUTO_SYNC",
  PIXIEBRIX_CAMPAIGN_SYNC: 'PIXIEBRIX_CAMPAIGN_SYNC',
  PIXIEBRIX_GROUP_SYNC: 'PIXIEBRIX_GROUP_SYNC',
  PIXIEBRIX_TEAM_LEADER_SYNC: 'PIXIEBRIX_DB_DATA_SYNC'
};

export const CRON_JOB_NAME = {
  EMPLOYEE_MASTER_SYNC: "EmployeeMasterSyncJob",
  AD_MANAGER_SYNC: "AdManagerSyncJob",
  PIXIEBRIX_TEAM_LEAD_SYNC: "PixiebrixDBDataSynchJob",
  PIXIEBRIX_CAMPAIGN_SYNC: "PixiebrixCampaignSynchJob",
  PIXIEBRIX_GROUP_SYNC: "PixiebrixGroupSynchJob",
  AP_PROHANCE_SYNC: "ProhanceSynchJob",
  AP_FALCON_SYNC: "PixiebrixSynchJob",

};

export const JOB_STATUS = {
  STARTED: "Started",
  ERROR: "Error",
  INPROGRESS: "InProgress",
  FINISHED: "Finished"
};

export const URLPATTERN = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/

export const FALCONDATATYPE = [
  {
    key: "CAMPAIGN",
    label: "Campaign",
  },
  {
    key: "GROUP",
    label: "Group",
  },
  {
    key: "DATABASE",
    label: "Database",
  },
];

export const CronExpression = [
  // { label: "EVERY_SECOND", key: "* * * * * *",jobstatus:true},
  // { label: "EVERY_5_SECONDS", key: "*/5 * * * * *" },
  // { label: "EVERY_10_SECONDS", key: "*/10 * * * * *" },
  // { label: "EVERY_30_SECONDS", key: "*/30 * * * * *" },
  // { label: "EVERY_MINUTE", key: "*/1 * * * *" },
  // { label: "EVERY_5_MINUTES", key: "0 */5 * * * *" },
  // { label: "EVERY_10_MINUTES", key: "0 */10 * * * *" },
  { label: "EVERY_30_MINUTES", key: "0 */30 * * * *" },
  { label: "EVERY_HOUR", key: "0 0-23/1 * * *" },
  { label: "EVERY_2_HOURS", key: "0 0-23/2 * * *" },
  { label: "EVERY_3_HOURS", key: "0 0-23/3 * * *" },
  { label: "EVERY_4_HOURS", key: "0 0-23/4 * * *" },
  { label: "EVERY_5_HOURS", key: "0 0-23/5 * * *" },
  { label: "EVERY_6_HOURS", key: "0 0-23/6 * * *" },
  { label: "EVERY_7_HOURS", key: "0 0-23/7 * * *" },
  { label: "EVERY_8_HOURS", key: "0 0-23/8 * * *" },
  { label: "EVERY_9_HOURS", key: "0 0-23/9 * * *" },
  { label: "EVERY_10_HOURS", key: "0 0-23/10 * * *" },
  { label: "EVERY_11_HOURS", key: "0 0-23/11 * * *" },
  { label: "EVERY_12_HOURS", key: "0 0-23/12 * * *" },
  { label: "EVERY_DAY_AT_1AM", key: "0 01 * * *" },
  { label: "EVERY_DAY_AT_2AM", key: "0 02 * * *" },
  { label: "EVERY_DAY_AT_3AM", key: "0 03 * * *" },
  { label: "EVERY_DAY_AT_4AM", key: "0 04 * * *" },
  { label: "EVERY_DAY_AT_5AM", key: "0 05 * * *" },
  { label: "EVERY_DAY_AT_6AM", key: "0 06 * * *" },
  { label: "EVERY_DAY_AT_7AM", key: "0 07 * * *" },
  { label: "EVERY_DAY_AT_8AM", key: "0 08 * * *" },
  { label: "EVERY_DAY_AT_9AM", key: "0 09 * * *" },
  { label: "EVERY_DAY_AT_10AM", key: "0 10 * * *" },
  { label: "EVERY_DAY_AT_11AM", key: "0 11 * * *" },
  { label: "EVERY_DAY_AT_NOON", key: "0 12 * * *" },
  { label: "EVERY_DAY_AT_1PM", key: "0 13 * * *" },
  { label: "EVERY_DAY_AT_2PM", key: "0 14 * * *" },
  { label: "EVERY_DAY_AT_3PM", key: "0 15 * * *" },
  { label: "EVERY_DAY_AT_4PM", key: "0 16 * * *" },
  { label: "EVERY_DAY_AT_5PM", key: "0 17 * * *" },
  { label: "EVERY_DAY_AT_6PM", key: "0 18 * * *" },
  { label: "EVERY_DAY_AT_7PM", key: "0 19 * * *" },
  { label: "EVERY_DAY_AT_8PM", key: "0 20 * * *" },
  { label: "EVERY_DAY_AT_9PM", key: "0 21 * * *" },
  { label: "EVERY_DAY_AT_10PM", key: "0 22 * * *" },
  { label: "EVERY_DAY_AT_11PM", key: "0 23 * * *" },
  { label: "EVERY_DAY_AT_MIDNIGHT", key: "0 0 * * *" },
  { label: "EVERY_WEEK", key: "0 0 * * 0" },
  { label: "EVERY_WEEKDAY", key: "0 0 * * 1-5" },
  { label: "EVERY_WEEKEND", key: "0 0 * * 6,0" },
  { label: "EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT", key: "0 0 1 * *" },
  { label: "EVERY_1ST_DAY_OF_MONTH_AT_NOON", key: "0 12 1 * *" },
  { label: "EVERY_2ND_HOUR", key: "0 */2 * * *" },
  { label: "EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM", key: "0 1-23/2 * * *" },
  { label: "EVERY_2ND_MONTH", key: "0 0 1 */2 *" },
  { label: "EVERY_QUARTER", key: "0 0 1 */3 *" },
  { label: "EVERY_6_MONTHS", key: "0 0 1 */6 *" },
  { label: "EVERY_YEAR", key: "0 0 1 0 *" },
  { label: "EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM", key: "0 */30 9-17 * * *" },
  { label: "EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM", key: "0 */30 9-18 * * *" },
  { label: "EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM", key: "0 */30 10-19 * * *" },
  { label: "MONDAY_TO_FRIDAY_AT_1AM", key: "0 0 01 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_2AM", key: "0 0 02 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_3AM", key: "0 0 03 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_4AM", key: "0 0 04 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_5AM", key: "0 0 05 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_6AM", key: "0 0 06 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_7AM", key: "0 0 07 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_8AM", key: "0 0 08 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_9AM", key: "0 0 09 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_09_30AM", key: "0 30 09 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_10AM", key: "0 0 10 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_11AM", key: "0 0 11 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_11_30AM", key: "0 30 11 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_12PM", key: "0 0 12 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_1PM", key: "0 0 13 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_2PM", key: "0 0 14 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_3PM", key: "0 0 15 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_4PM", key: "0 0 16 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_5PM", key: "0 0 17 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_6PM", key: "0 0 18 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_7PM", key: "0 0 19 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_8PM", key: "0 0 20 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_9PM", key: "0 0 21 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_10PM", key: "0 0 22 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_11PM", key: "0 0 23 * * 1-5" },
];

export const HOST_IP = [
  { label: "Google.com", key: "google.com", ip: "192.178.0.1" },
  { label: "Yahoo.com", key: "yahoo.com", ip: "192.178.0.2" },
  { label: "Facebook.com", key: "facebook.com", ip: "192.178.0.3" },
  { label: "Bing.com", key: "bing.com", ip: "192.178.0.4" },
  { label: "Twitter.com", key: "twitter.com", ip: "192.178.0.5" },
]
export const NON_GLOBAL_JOBS = ['PIXIEBRIX']
export const APPLICATION_LOCAL_STORAGE = {
  REFRESH_TOKEN: 'refreshToken', // use for regenerate the authtoken
  TOKEN_TIME_STAMP: 'tokenTimestamp', // last authtoken generation timestamp.
  SESSION_TIMEOUT_IN_MILLI_SECONDS: 'sessionTimeoutInMilliseconds',
  AUTH_TOKEN: 'authToken', // User auth token
  REFRESH_TOKEN_LAST_UPDATED_AT: 'refreshTokenLastUpdatedAt', //  This is only for view purpose
  PING_ACCESS_TOKEN: 'pingAccessToken', // Ping Auth Token
  SESSION_TIMEOUT: 'sessionTimeOut',
 
};
export const AUTH_TOKEN_GENERATION_TIME_IN_SEC = 5000;
export const REDIRECTION_PAGE = {
  LOGIN_PAGE: '/login', // use only for web application
};
export const STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 403,
  INTERNAL_SERVER_ERROR: 500,
  CREATED: 201,
  UNAUTHORIZED: 401,
  PRECONDITION_FAILED: 412,
};



export const ADD_PROJECT_MODAL_CONSTANTS = {
    modalTitle: 'Add New Project',
    projectNameLabel: 'Project Name',
    projectDescriptionLabel: 'Project Description',
    projectNamePlaceholder: 'Enter project name',
    projectDescriptionPlaceholder: 'Enter project description',
    requiredMark: '*',
    createButtonLabel: 'Create',
    creatingButtonLabel: 'Creating...',
    enabledLabel: 'Enabled',
    disabledLabel: 'Disabled',
    successMessage: 'Project added sucessfully!',
    errorMessage: 'Something went wrong',
    breadcrumb: {
        extra: [{ label: 'Add Project', icon: <FolderOpenOutlined /> }],
        overrides: {
            '/projects': {
                label: 'Projects',
                icon: <FolderOpenOutlined />,
                path: '/projects/overview',
            },
        },
    },
    icons: {
        plus: <PlusCircleOutlined className="modal-icon" />,
        close: <CloseOutlined />,
    }
};

export const DYNAMIC_FORM_MODAL_CONSTANTS = {
    dialogMaxWidth: 'sm',
    jobRunSuccessMsg: 'Job started successfully!',
    jobRunFailedMsg: 'Failed to start job:',
    submitButtonLabel: 'Submit',
    configTitle: 'Configuration Setting',
    runTitle: 'Job Run Details',
    disclaimerText: "Please review all values carefully before running the job. Changes cannot be undone.",
    icons: {
        setting: <SettingOutlined className="config-icon" />,
        close: <CloseOutlined />,
        info: <InfoOutlined style={{ color: '#EDB300', marginRight: '8px' }} />,
    },
};

export const FIELD_DATA_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  TIME: 'time',
};

export const CONNECTION_DETAILS_CONSTANTS = {
  FIELDS: {
    NAME: 'name',
    AUTH_TYPE: 'authType',
    CLIENT_ID: 'clientId',
  },
  LABELS: {
    NAME: 'Connection name',
    AUTH_TYPE: 'Auth type',
    CLIENT_ID: 'Client ID',
  },
  HELPER_TEXTS: {
    NAME: 'Name your connection. You can reuse it in other recipes.',
    AUTH_TYPE: 'Select authentication type used to connect.',
    CLIENT_ID: (
      <>
        To create client ID, register an application. Click{' '}
        <a href="https://yourlink.com" target="_blank" rel="noopener noreferrer">here</a>.
      </>
    ),
  },
  BUTTON_TEXT: {
    EDIT: 'Edit',
    DELETE: 'Delete',
    SAVE: 'Save',
    CANCEL: 'Cancel',
  },
};

export const PROJECT_DETAILS_CONSTANTS = {
  TABS: ['Jobs'],  // can be expanded later if needed

  TAB_NAMES: {
    JOBS: 'Jobs',
    CONNECTORS: 'Connectors',
  },

  BREADCRUMB_OVERRIDES_BASE: {
    '/projects': {
      label: 'Projects',
      icon: <FolderOpenOutlined />,
      path: '/projects/overview',
    },
  },

  BREADCRUMB_EXTRA: {
    JOBS: [
      {
        label: 'Jobs',
        icon: <FolderOpenOutlined />,
      },
    ],
    CONNECTORS: [
      {
        label: 'Connectors',
        icon: <FolderOpenOutlined />,
      },
    ],
  },

  BUTTON_LABELS: {
    ADD_JOB: 'Add Job',
    ADD_CONNECTION: 'Add Connection',
  },

  NO_PROJECT_SELECTED_MESSAGE: 'No project selected.', 
};

export const JOBS_CONSTANTS = {
  ITEMS_PER_PAGE: 10,

  SEARCH: {
    PLACEHOLDER: 'Search Jobs',
  },

  STATUS_FILTER_OPTIONS: [
    { value: '', label: 'All status' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'InActive' },
  ],

  PAGINATION: {
    SHOWING_TEXT: (start, end, total) => `Showing ${start}–${end} of ${total} jobs`,
    SYNC_BUTTON_LABEL: 'Sync Now',
    SYNC_ICON: <ReloadOutlined/>,
    PREVIOUS: '<',
    NEXT: '>',
  },

  FILTER_STATUS_MAPPING: {
    Active: 0,   
    Inactive: 1,  
  },
};

export const JOBSCARD_CONSTANTS = {
  MENU_ACTIONS: {
    START: 'start',
    CONFIG: 'config',
    EDIT: 'edit',
  },

  MENU_LABELS: {
    RUN_JOB: 'Run Job',
    CONFIG: 'Config',
    EDIT: 'Edit',
  },

  MESSAGES: {
    JOB_STARTED_SUCCESS: 'Job started successfully!',
  },
};

export const CRON_JOB_CONSTANTS = {
  TABS: ['Execution Logs'],
  NOLOGFOUNDTITLE:"No Logs found",
  NOLOGFOUNDSUBTEXT: 'Try adjusting your search or filters',
  BREADCRUMB_EXTRA: [
    {
      label: 'Logs',
      icon: <FolderOpenOutlined />,
    },
  ],

  BREADCRUMB_OVERRIDES: (title, jobName, selectedProject, selectedJob) => ({
    '/projects': {
      label: 'Projects',
      icon: <FolderOpenOutlined />,
      path: '/projects/overview',
    },
    [`/projects/${encodeURIComponent(title)}`]: {
      label: selectedProject?.name,
      disabled: false,
    },
    [`/projects/${encodeURIComponent(title)}/${encodeURIComponent(jobName)}`]: {
      label: selectedJob?.name,
      disabled: false,
    },
  }),
};

export const LogDetailsDrawerConstants = {
  drawerTitle: 'Execution Logs Details',
  logInfoTitle: 'Log Info',
  noLogSelected: 'No log selected.',

  getBreadcrumbOverrides: (title, jobName) => ({
    '/projects': {
      label: 'Projects',
      icon: <FolderOpenOutlined />,
      path: '/projects/overview'
    },
    [`/projects/${encodeURIComponent(title)}`]: {
      label: title,
      disabled: false
    },
    [`/projects/${encodeURIComponent(title)}/${encodeURIComponent(jobName)}`]: {
      label: jobName,
      disabled: false
    }
  })
};

export const AddJobFormConstants = {
  title: {
    create: 'Create Job',
    edit: 'Edit Job',
  },
  labels: {
    jobName: 'Job Name',
    schedule: 'Schedule (Cron)',
    timezone: 'Timezone',
    description: 'Description',
    enabled: 'Enabled',
    disabled: 'Disabled',
    cronHint: 'Specify the cron expression.',
    cronConfigure: 'Configure Crons',
  },
  placeholders: {
    jobName: 'Nightly database sync',
    description: 'Optional job description...',
  },
  errors: {
    jobName: 'Job name is required',
    cron: 'Cron schedule is required',
    timezone: 'Timezone is required',
  },
  button: {
    create: 'Create Job',
    update: 'Update Job',
    creating: 'Creating...',
    updating: 'Updating...',
  },
  timezones: [
    { label: 'UTC', value: 'UTC' },
    { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
    { label: 'America/New_York', value: 'America/New_York' },
  ],
  getBreadcrumbOverrides: (title, jobName) => ({
    '/projects': {
      label: 'Projects',
      path: '/projects/overview',
    },
    [`/projects/${encodeURIComponent(title)}`]: {
      label: title,
      disabled: false,
    },
    ...(jobName && {
      [`/projects/${encodeURIComponent(title)}/${encodeURIComponent(jobName)}`]: {
        label: jobName,
        disabled: false,
      },
    }),
  }),
};

export const NoJobsFoundConstants = {
  icon: {
    ariaLabel: 'No jobs found icon',
  },
  title: 'No jobs found',
  subtext: 'Try adjusting your search or filters',
};

export const projectOverviewConstants = {
  breadcrumbsOverrides: {
    '/projects': {
      label: 'Projects',
      icon: <FolderOpenOutlined />,
      path: '/projects/overview',
    },
  },
  header: {
    title: 'Automation Projects',
    subtitle: 'Manage your cron job projects',
    newProjectButton: {
      label: 'New Project',
      startIcon: <PlusOutlined />,
    },
  },
  searchBar: {
    placeholder: 'Search projects',
    inputStyle: {
      height: '30px',
      fontSize: '0.85rem',
    },
  },
  pagination: {
    size: 'small',
    sx: {
      '& .Mui-selected': {
        backgroundColor: '#667AFF',
        color: '#fff',
      },
    },
  },
  noProjectsFound: {
    message: 'No jobs found',
  },
  showingText: (start, end, total) =>
    `Showing ${total === 0 ? 0 : start}–${end} of ${total} projects`,
};

export const projectCardConstants = {
  statusLabels: {
    active: 'Active',
    inactive: 'Inactive',
  },
  labels: {
    jobs: 'Jobs',
    connections: 'Connections',
    created: 'Created',
  },
};









